<template>
  <contact-form-fieldset
    class="contact-form__contact-info"
    :legend="texts.yourContactInfo"
  >
    <form-input
      autocomplete="name"
      name="name"
      type="text"
      ref="name"
      v-model="nameModel"
      :label="texts.name"
      :required="true"
      @trigger-field-error="triggerFieldError"
    />

    <form-input
      name="email"
      type="email"
      ref="email"
      v-model="emailModel"
      :check-email-on-blur="true"
      :label="texts.email"
      :required="emailIsRequired"
      @trigger-field-error="triggerFieldError"
    />

    <form-input
      name="phone"
      type="tel"
      ref="phone"
      v-model="phoneModel"
      :label="texts.phone"
      :required="true"
      @trigger-field-error="triggerFieldError"
    />

    <form-textarea
      name="message"
      v-model="messageModel"
      :auto-height="true"
      :label="messageLabel"
      :required="messageIsRequired"
      :rows="'3'"
    />
  </contact-form-fieldset>
</template>

<script>
  import FormInput from "Components/FormInput.vue";
  import FormTextarea from "Components/FormTextarea.vue";
  import { isTherapyRequest } from "Main/contact-form/constants";
  import ContactFormFieldset from "./ContactFormFieldset.vue";

  export default {
    components: {
      ContactFormFieldset,
      FormInput,
      FormTextarea,
    },

    computed: {
      emailModel: {
        get() {
          return this.email;
        },
        set(value) {
          this.$emit("update:email", value);
        },
      },

      messageLabel() {
        if (this.messageIsRequired) {
          return this.texts.messageRequiredPlaceholder;
        }

        if (isTherapyRequest(this.requestType)) {
          return this.texts.messageNotRequiredPlaceholderTherapy;
        }

        return this.texts.messageNotRequiredPlaceholder;
      },

      messageModel: {
        get() {
          return this.message;
        },
        set(value) {
          this.$emit("update:message", value);
        },
      },
      nameModel: {
        get() {
          return this.name;
        },
        set(value) {
          this.$emit("update:name", value);
        },
      },

      phoneModel: {
        get() {
          return this.phone;
        },
        set(value) {
          this.$emit("update:phone", value);
        },
      },
    },

    data() {
      return {
        texts: theme_vars.contactTexts,
      };
    },

    methods: {
      triggerFieldError() {
        this.$emit("trigger-field-error");
      },
    },
    name: "ContactInfo",

    props: {
      email: {
        default: "",
        type: String,
      },
      emailIsRequired: {
        default: () => true,
        type: Boolean,
      },
      message: {
        default: "",
        type: String,
      },
      messageIsRequired: {
        default: () => false,
        type: Boolean,
      },
      name: {
        default: "",
        type: String,
      },
      phone: {
        default: "",
        type: String,
      },
      requestType: {
        default: "",
        type: String,
      },
    },
  };
</script>
